export function getCollectionUrlBySlug(
  slug: string,
  tab?: string,
  locale?: string,
) {
  const basePath = locale ? `/${locale}` : ""
  return tab
    ? `${basePath}/collection/${slug}/${tab}`
    : `${basePath}/collection/${slug}`
}
